import React from 'react';
import { Plus } from 'lucide-react';

/**
 * The chrome every filter builder wears — runs, spans, evals, alerts.
 *
 * These panels were each styled by hand and drifted apart: dotted borders in
 * one place and solid everywhere else, 24px of padding around a single small
 * link so the panel read as a hole in the page, and three type sizes in one
 * box (12px bold section labels, 14px "Add", 12px chips). Same widget, four
 * different looks. One definition here, imported by all of them.
 */

/** The outer box. On its own surface — a transparent panel over the page read as a black gap. */
export const QUERY_PANEL_CLASS =
  'overflow-visible rounded-xl border border-[color:var(--border-default)] bg-transparent';

/** The strip a section name sits in. */
export const QUERY_SECTION_HEADER_CLASS =
  'px-3 pt-2.5';

/** The section name itself — the app's one section-label size, everywhere. */
export const QUERY_SECTION_LABEL_CLASS =
  'text-[11px] font-medium lowercase text-[color:var(--text-muted)] first-letter:uppercase';

/** What the section holds. Breathing room, not a room. */
export const QUERY_SECTION_BODY_CLASS = 'space-y-2 px-3 pb-3 pt-1.5';

/** The line between two sections. */
export const QUERY_SECTION_DIVIDER_CLASS = 'mx-3 border-t border-[color:var(--border-default)]';

/**
 * Adds a row to a builder: a quiet pill that sits among the chips it adds.
 */
export function AddControlButton({ label = 'Add', onClick, buttonRef, title }) {
  return (
    <button
      ref={buttonRef}
      type="button"
      onClick={onClick}
      title={title}
      className="inline-flex h-7 items-center gap-1 rounded-lg px-2 text-[12px] font-medium text-[color:var(--text-secondary)] transition-colors hover:bg-surface-hover hover:text-[color:var(--text-primary)]"
    >
      <Plus size={13} />
      <span>{label}</span>
    </button>
  );
}
